import React from "react";
import { useSelector } from "react-redux";
import { Skeleton, Stack } from "@mui/material";
import { useTranslation } from "@helpers/translate";
import { CustomScrollTable } from "../../../CustomScrollTable";
import { PairRow } from "./PairRow";
import EmptyIcon from "@assets/images/icons/no-date-icon.svg";

const SKELETON_ROWS = [1, 2, 3];

/**
 * Loading / empty / list states of the pairs modal.
 *
 * @param {object} props
 * @param {object[]} props.pairs
 * @param {boolean} props.loading
 * @param {(pair: object) => void} props.onSelect
 * @param {(slug: string) => boolean} props.isFavorite
 * @param {(pair: object) => void} props.onToggleFavorite
 */
export const PairsList = ({
  pairs,
  loading,
  onSelect,
  isFavorite,
  onToggleFavorite,
}) => {
  const { __ } = useTranslation();
  const tickersMap = useSelector((state) => state.futures.tickersMap);

  if (loading) {
    return (
      <Stack spacing="14px" className="futures-pairs__skeletons">
        {SKELETON_ROWS.map((item) => (
          <Skeleton
            key={item}
            className="futures-pairs__skeleton"
            variant="rounded"
            width="100%"
            height={25}
          />
        ))}
      </Stack>
    );
  }

  if (!pairs.length) {
    return (
      <div className="futures-pairs__empty">
        <img src={EmptyIcon} alt="" />
        <p>{__("trading.pairs_nf")}</p>
      </div>
    );
  }

  return (
    <CustomScrollTable
      isTable={false}
      maxHeight="100%"
      containerClassName="futures-pairs__scroll"
    >
      <ul className="futures-pairs__list">
        {pairs.map((pair) => (
          <PairRow
            key={pair.id}
            pair={pair}
            ticker={tickersMap?.[pair.slug.toLowerCase()]}
            isFavorite={isFavorite(pair.slug)}
            onSelect={onSelect}
            onToggleFavorite={onToggleFavorite}
          />
        ))}
      </ul>
    </CustomScrollTable>
  );
};
